// extracted by mini-css-extract-plugin
module.exports = {"content":"ZmS_j","summary-text":"_2wQaT","summary-elememt":"_1xUGa"};